export default "__VITE_ASSET__D8gLXd5C__"